/* eslint-disable react/forbid-prop-types,react/no-unused-prop-types,no-shadow */

import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import MomentTz from 'moment-timezone';
import _ from 'lodash';
import {
  toggleAssetPublish,
  clearLogs,
  resetAssetPublish,
  queryAssetPublishLogs, AccessLogActionTypes,
} from '../../../../state/assetPublishes';
import { isOwnerOfAsset } from '../../../../utils/assetDetails/isOwnerOfAsset';
import { selectIsUserVaultSuperAdmin, selectUserRole } from '../../../../state/user/userOrgRole';
import Warning from '../../Warning';
import { IAppState } from '../../../../state/reducers';
import { IProps, IDispatchProps, IStateProps } from './interfaces';
import { AccordionContainer, AccordionDetailsContainer } from './styles';
import { IColumn } from '../../../Search/SearchTable/interfaces';

class AssetPublishes extends PureComponent<IProps, null> {
  private headCells: any[] = [];

  constructor(props: IProps) {
    super(props);

    this.headCells = [
      { id: 'orgName', label: 'Organization' },
      { id: 'publishType', label: 'Type' },
      { id: 'actionDate', label: 'Time' },
    ];
  }

  handleToggle = () => {
    const {
      isOpen,
      rawAssetDetails,
      toggleAssetPublish,
      queryAssetPublishLogs,
      clearLogs,
    } = this.props;

    if (isOpen) {
      clearLogs();
      toggleAssetPublish();
    } else {
      queryAssetPublishLogs(rawAssetDetails._id, true);
    }
  };

  componentDidUpdate = (prevProps: IProps) => {
    const { resetAssetPublish, rawAssetDetails } = this.props;

    if (!_.isEqual(rawAssetDetails, prevProps.rawAssetDetails)) {
      resetAssetPublish();
    }
  };

  formatPublishType = (publishType: AccessLogActionTypes) => {
    switch (publishType) {
      case AccessLogActionTypes.PublishLAN:
        return 'LAN';
      case AccessLogActionTypes.PublishYahoo:
        return 'Yahoo';
      case AccessLogActionTypes.PublishYoutube:
        return 'Youtube';
      case AccessLogActionTypes.PublishTwitter:
        return 'Twitter';
      default:
        return 'Unknown';
    }
  };

  render() {
    const {
      rawAssetDetails,
      isOpen,
      logs,
      securityProfiles: { isLoaded, idValueMapping },
      userRole,
      isSuperAdmin,
    } = this.props;

    const isOwner = isLoaded ? isOwnerOfAsset(userRole, rawAssetDetails, idValueMapping) : false;

    if (!isOwner && !isSuperAdmin) {
      return null;
    }

    return (
      <>
        <AccordionContainer
          expanded={isOpen}
          onChange={this.handleToggle}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography>Asset Publishes</Typography>
          </AccordionSummary>
          <AccordionDetailsContainer>
            <Warning
              isWarning={logs.length === 0}
              message="Publishes not found"
              fullWidth
            />
            {logs.length > 0 && (
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      {this.headCells.map((cell) => (
                        <TableCell
                          key={cell.id}
                          align="center"
                        >
                          {cell.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {logs.map((log) => (
                      <TableRow>
                        <TableCell align="center">
                          {log._source.orgName}
                        </TableCell>
                        <TableCell align="center">
                          {this.formatPublishType(log._source.actionType)}
                        </TableCell>
                        <TableCell align="center">
                          {MomentTz.tz(log._source.actionDate, MomentTz.tz.guess()).format('L LT')}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </AccordionDetailsContainer>
        </AccordionContainer>
      </>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.assetPublishes.isOpen,
  logs: state.assetPublishes.logs,
  securityProfiles: state.securityProfiles,
  userRole: selectUserRole(state),
  isSuperAdmin: selectIsUserVaultSuperAdmin(state),
});

const mapDispatchToProps: IDispatchProps = {
  toggleAssetPublish,
  clearLogs,
  resetAssetPublish,
  queryAssetPublishLogs,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetPublishes);
